import type { ReactNode } from "react";
import { useImmer } from "use-immer";

import {
  DrawerConfig,
  DrawerContextValue,
  DrawerType,
  MobileDrawerContext,
} from "./types";

type DrawerState = {
  activeDrawer: DrawerType | null;
  drawers: Record<DrawerType, DrawerConfig>;
};

export const MobileDrawerProvider = ({ children }: { children: ReactNode }) => {
  const [state, updateState] = useImmer<DrawerState>({
    activeDrawer: null,
    drawers: {} as DrawerState["drawers"],
  });

  const registerDrawer = (config: DrawerConfig) => {
    updateState((draft) => {
      draft.drawers[config.type] = config;
    });
  };

  const openDrawer = (type: DrawerType) => {
    updateState((draft) => {
      draft.activeDrawer = type;
    });
  };

  const closeDrawer = () => {
    updateState((draft) => {
      draft.activeDrawer = null;
    });
  };

  const isDrawerOpen = (type: DrawerType) => state.activeDrawer === type;

  const getActiveDrawerConfig = (): DrawerConfig | undefined => {
    if (!state.activeDrawer) return undefined;
    return state.drawers[state.activeDrawer];
  };

  const value: DrawerContextValue = {
    activeDrawer: state.activeDrawer,
    registerDrawer,
    openDrawer,
    closeDrawer,
    isDrawerOpen,
    getActiveDrawerConfig,
  };

  return (
    <MobileDrawerContext.Provider value={value}>
      {children}
    </MobileDrawerContext.Provider>
  );
};
